import { Picker } from "@certn/cascadia-react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../../hooks/useQueryParams";
import { normalizePackageOrdering } from "../../utils";

export function SortFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { packageImprovements } = useFlags();

  const sortOptions = [
    ...(packageImprovements
      ? [
          { id: "-is_active", name: t("Active first") },
          { id: "-modified", name: t("Date Modified: New to old") },
          { id: "modified", name: t("Date Modified: Old to New") },
        ]
      : [
          { id: "-created", name: t("Created date: New to old") },
          { id: "created", name: t("Created date: Old to New") },
        ]),
    { id: "name", name: t("Name: A to Z") },
    { id: "-name", name: t("Name: Z to A") },
    { id: "-case_count", name: t("Most used") },
    { id: "case_count", name: t("Least used") },
  ];

  const ordering = normalizePackageOrdering(
    params.ordering,
    packageImprovements
  );
  const selectedOrdering = ordering
    ? Array.isArray(ordering)
      ? ordering
      : [ordering]
    : [];

  return (
    <Picker
      label={t("Sort")}
      showActionBar
      selectionMode="single"
      selectedKeys={selectedOrdering}
      onSelectionChange={(keys) => setParam("ordering", Array.from(keys))}
      items={sortOptions}
      testID="sort-filter-picker"
    />
  );
}
